import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertModel } from '../../viewmodels/alert.model';
import { AddAlertTextCopy } from '../../helper/textcopy/add-alert.text';
import { ReasonService } from '../../services/reason.service';
import { AdminService } from '../../../../layouts/services/admin.service';
import { SettingsService } from '../../../../authentication/services/settings.service';
import { bounceBubbleAnimation } from '../../../../app.animations';
import { Global } from '../../../../app.global';
// import { Select2UpdateEvent, Select2SearchEvent, Select2Option } from 'ng-select2-component';
import {
  Select2UpdateEvent,
  Select2SearchEvent,
  Select2Option,
} from '../../../../../../projects/ng-select2-component/src/public_api';
import { SearchSynonymsModel } from '../../viewmodels/searchSynonyms.model';
import { ReasonModel } from '../../viewmodels/reason.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'add-alert',
  templateUrl: './add-alert.component.html',
  styleUrls: ['./add-alert.component.scss'],
  animations: [bounceBubbleAnimation],
})
export class AddAlertComponent implements OnInit {
  alertCopy = AddAlertTextCopy;
  addEditPageTitle = 'Add alert';
  isEditPage = false;
  alert = new AlertModel();
  editAlertId = 0;
  bounceAlertsBubbleState: any = 1;
  // rmOnline = this.global.appSettings['RMOnline'] === 'True';
  rmOnline = false;

  select2OptionsCase: any;
  casesList: Array<any> = [];
  selectedCases = [];

  select2OptionsReason: any;
  reasonsObject = [];
  reasonsList: Array<any> = [];
  reasonSearchData: Array<Select2Option> = [];
  searchSynonyms: Array<SearchSynonymsModel> = [];
  reasonsUnformattedList: Array<ReasonModel>;

  selectedReasons = [];

  documentsObject = [];
  select2OptionsDocument: any;
  documentsList: Array<any> = [];
  documentsSearchData: Array<Select2Option> = [];
  // documentsSearchSynonyms: Array<SearchSynonymsModel> = [];
  documentsUnformattedList: Array<ReasonModel>;
  selectedDocuments = [];

  selectedPolicies = [];
  policies = [];
  selectedPolicyCat = '';
  visiblePolicieSection = {};

  pcnTypes = [];
  pcnStages = [];

  disabledStagesForLetter = ['CCSent', 'OFRSent', 'Bailiffs'];

  formErrorField = '';

  createdOn: Date;
  issuedStartDate: Date;
  issuedEndDate: Date;
  modifiedOn: Date;
  startDate: Date;
  whenOrdered: Date;
  endDate: Date;
  pcnStartDate: Date;
  pcnEndDate: Date;
  debounceTimer: any;

  constructor(
    private route: ActivatedRoute,
    private reasonService: ReasonService,
    private router: Router,
    private adminService: AdminService,
    private modalService: NgbModal,
    private settingsService: SettingsService,
    public global: Global
  ) {
    this.route.params.subscribe((params) => {
      if (params.id !== undefined) {
        this.editAlertId = params.id;
        this.isEditPage = true;
      }
    });

    // this.settingsService.getApplicationSetting("RMOnline")
    // .subscribe(
    //   result =>{
    //     this.rmOnline = result;
    //   },
    //   err =>{
    //     this.rmOnline = false;
    //   }
    // );

    // set RMOnline variable
    this.rmOnline = this.global.RmOnline;
  }

  ngOnInit() {
    this.setDefaultAlertValues();

    // this.setSelect2OptionsCase();
    // this.setSelect2OptionsReason();
    // this.setSelect2OptionsDocument();

    this.setPcnTypes();
    this.setPcnStages();
    this.setLetterCases();

    if (this.isEditPage) {
      this.addEditPageTitle = 'Edit alert';
      this.setEditAlert();
      this.setReasonsList();
      this.setDocumentsList();
      this.setPoliciesList();
    }
  }

  setDefaultAlertValues() {
    this.alert.howOrderedId = 0;
    this.alert.whenOrdered = new Date();
    this.alert.endDate = new Date();
    this.alert.letterTypeId = 0;
    this.alert.decisionId = 0;
    this.alert.paragraphLocationId = 0;
    this.alert.paragraphAutoSelect = false;
  }

  setDefaultAlertValuesIfNull() {
    if (this.alert.howOrderedId === null) {
      this.alert.howOrderedId = 0;
    }
    if (this.alert.letterTypeId === null) {
      this.alert.letterTypeId = 0;
    }
    if (this.alert.decisionId === null) {
      this.alert.decisionId = 0;
    }
    if (this.alert.paragraphLocationId === null) {
      this.alert.paragraphLocationId = 0;
    }
    if (this.alert.paragraphAutoSelect === null) {
      this.alert.paragraphAutoSelect = false;
    }
    // if (this.alert.issuedStartDate === null) {
    //  this.alert.issuedStartDate = new Date;
    // }
    // if (this.alert.issuedEndDate === null) {
    //  this.alert.issuedEndDate = new Date;
    // }
  }

  setEditAlert() {
    this.adminService.getAlertById(this.editAlertId).subscribe((result) => {
      if (result) {
        console.log(result);
        this.alert = result;
        this.setDefaultAlertValuesIfNull();
        this.setDatesFormat();
        this.setSelectedPcnTypes();
        this.setSelectedPcnStages();
        this.setSelectedCases();
        this.selectedPolicies = this.alert.policies;
      }
    });
  }

  setDatesFormat() {
    this.createdOn = this.alert.createdOn !== null ? moment(this.alert.createdOn).toDate() : null;
    this.endDate = this.alert.endDate !== null ? moment(this.alert.endDate).toDate() : null;
    this.issuedStartDate =
      this.alert.issuedStartDate !== null ? moment(this.alert.issuedStartDate).toDate() : null;
    this.issuedEndDate =
      this.alert.issuedEndDate !== null ? moment(this.alert.issuedEndDate).toDate() : null;
    this.modifiedOn =
      this.alert.modifiedOn !== null ? moment(this.alert.modifiedOn).toDate() : null;
    this.startDate = this.alert.startDate !== null ? moment(this.alert.startDate).toDate() : null;
    this.whenOrdered =
      this.alert.whenOrdered !== null ? moment(this.alert.whenOrdered).toDate() : null;
  }

  setLetterCases() {
    this.adminService.getLetterCasesAlert().subscribe((result) => {
      if (result) {
        result.forEach((letterCase) => {
          const newCase = {
            id: letterCase.id,
            text: letterCase.description,
          };
          this.casesList.push(newCase);
        });
        this.casesList = this.casesList.slice();
        if (this.isEditPage) {
          this.setSelectedCases();
        }
      }
    });
  }

  setReasonsList() {
    this.adminService.getAllReasons().subscribe((reasonUnformattedList) => {
      if (reasonUnformattedList) {
        this.reasonsList = reasonUnformattedList;
        this.createReasonsList();
        if (this.isEditPage) {
          this.setSelectedReasons();
        }
      }
    });
  }

  onSelectReasons(event: Select2UpdateEvent) {
    if (this.selectedReasons === null) {
      this.selectedReasons = [];
    }
  }

  onReasonsSearch(event: Select2SearchEvent) {
    event.filteredData(
      event.search
        ? event.data.filter((option) => {
            // convert search and label to lowercase to handle case-sensitivity
            const searchTerm = event.search.toLowerCase();
            const label = option.label.toLowerCase();

            // check if the label or any synonym contains the search term
            return (
              label.includes(searchTerm) ||
              (option.data.synonyms &&
                option.data.synonyms.some((synonym) => synonym.toLowerCase().includes(searchTerm)))
            );
          })
        : event.data
    );
  }

  generateReasonsObject(result) {
    this.reasonsObject = this.reasonService.generateReasonsObject(result);
  }

  createReasonsList() {
    this.reasonSearchData = [];

    this.reasonsList.forEach((reason) => {
      const searchSynonymsModel = new SearchSynonymsModel(); // Creating a new instance
      searchSynonymsModel.representationItemCategorisationId = reason.id; // Assigning reason.Id to representationItemCategorisationId
      searchSynonymsModel.reasonName = reason.name; // Assigning reason.name to reasonName
      searchSynonymsModel.synonyms = reason.synonyms; // Assigning synonyms to synonyms array

      // Pushing the created instance into the searchSynonymsList array
      this.searchSynonyms.push(searchSynonymsModel);

      // Create a new Select2Data object
      const newSelect2Data: Select2Option = {
        label: reason.name,
        value: reason.id,
        data: reason,
      };
      this.reasonSearchData.push(newSelect2Data);
    });
  }

  setDocumentsList() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.adminService.getAllDocuments().subscribe((documentsUnformattedList) => {
        if (documentsUnformattedList) {
          this.documentsList = documentsUnformattedList;
          this.createDocumentsList();
          if (this.isEditPage) {
            this.setSelectedDocuments();
          }
        }
      });
    }, 300);
  }
  onSelectDocuments(event: Select2UpdateEvent) {
    if (this.selectedDocuments === null) {
      this.selectedDocuments = [];
    }
  }

  onDocumentsSearch(event: Select2SearchEvent) {
    event.filteredData(
      event.search
        ? event.data.filter((option) => {
            // convert search and label to lowercase to handle case-sensitivity
            const searchTerm = event.search.toLowerCase();
            const label = option.label.toLowerCase();

            // check if the label or any synonym contains the search term
            return (
              label.includes(searchTerm) ||
              (option.data.synonyms &&
                option.data.synonyms.some((synonym) => synonym.toLowerCase().includes(searchTerm)))
            );
          })
        : event.data
    );
  }

  generateDocumentsObject(result) {
    this.documentsObject = this.reasonService.generateReasonsObject(result);
  }

  createDocumentsList() {
    this.documentsSearchData = [];

    this.documentsList.forEach((reason) => {
      const searchSynonymsModel = new SearchSynonymsModel(); // Creating a new instance
      searchSynonymsModel.representationItemCategorisationId = reason.id; // Assigning reason.Id to representationItemCategorisationId
      searchSynonymsModel.reasonName = reason.name; // Assigning reason.name to reasonName
      searchSynonymsModel.synonyms = reason.synonyms; // Assigning synonyms to synonyms array

      // Pushing the created instance into the searchSynonymsList array
      this.searchSynonyms.push(searchSynonymsModel);

      // Create a new Select2Data object
      const newSelect2Data: Select2Option = {
        label: reason.name,
        value: reason.id,
        data: reason,
      };
      this.documentsSearchData.push(newSelect2Data);
    });
  }

  setPoliciesList() {
    this.adminService.getAlertPoliciesRawObject().subscribe((result) => {
      if (result) {
        const permitCategories = [
          'business',
          'contract',
          'doctors',
          'marketTraders',
          'residents',
          'visitors',
          'custom',
        ];
        result.forEach((category) => {
          if (
            category.categoryId === 'concessionOther' ||
            category.categoryId === 'concessionsPayment'
          ) {
            category.categoryName = `concessions ${category.categoryName}`;
          } else if (permitCategories.indexOf(category.categoryId) > -1) {
            category.categoryName = `${category.categoryName} permit`;
          }
        });
        this.policies = result;
        this.selectedPolicyCat = this.policies[0].categoryId;
        this.visiblePolicieSection = this.policies[0];
      }
    });
  }

  setSelectedReasons() {
    this.selectedReasons = this.alert.reasons.map((str) => parseInt(str, 10));
  }

  setSelectedDocuments() {
    this.selectedDocuments = this.alert.documents.map((str) => parseInt(str, 10));
  }

  setSelectedCases() {
    if (this.alert.eventCode !== null) {
      this.selectedCases = [this.alert.eventCode];
    }
  }

  setPcnTypes() {
    this.pcnTypes = [
      {
        name: 'fixed-to-vehicle / handed-to-driver',
        value: 'PA',
        checked: false,
      },
      {
        name: 'CCTV (postal)',
        value: 'camera',
        checked: false,
      },
      {
        name: 'drive-away / prevented-from-issue (postal)',
        value: 'POSTAL',
        checked: false,
      },
    ];
  }

  setSelectedPcnTypes() {
    this.pcnTypes.forEach((type) => {
      if (this.alert.pcnTypes.indexOf(type.value) > -1) {
        type.checked = true;
      }
    });
  }

  setPcnStages() {
    this.pcnStages = [
      {
        name: 'discount',
        value: 'Discount',
        checked: false,
      },
      {
        name: 'full charge',
        value: 'FullCharge',
        checked: false,
      },
      {
        name: 'NTO sent after fixed-to-vehicle / handed-to-driver PCN',
        value: 'NTOSent',
        checked: false,
      },
      {
        name: 'CC sent',
        value: 'CCSent',
        checked: false,
      },
      {
        name: 'Order for Recovery sent (not Scotland)',
        value: 'OFRSent',
        checked: false,
      },
      {
        name: 'bailiffs / sheriff',
        value: 'Bailiffs',
        checked: false,
      },
    ];
  }

  setSelectedPcnStages() {
    this.pcnStages.forEach((stage) => {
      stage.checked = false;
    });
    this.pcnStages.forEach((stage) => {
      if (this.alert.stages.indexOf(stage.value) > -1) {
        stage.checked = true;
      }
    });
  }

  // cases autocomplete settings
  // setSelect2OptionsCase(): void {

  //   this.select2OptionsCase = {
  //     multiple: true,
  //     maximumSelectionLength: 1,
  //     placeholder: 'Enter the progression case...',
  //     width: '100%',
  //     templateResult: this.templateResultCase,
  //     templateSelection: this.templateSelectionCase,
  //     matcher: this.reasonService.select2Match
  //   };

  // }

  // templateResultCase(state): JQuery | string {

  //   const searchTerm = $('.app-select2.select2-case input.select2-search__field').val();
  //   const index = state.text.indexOf(searchTerm);
  //   const code = state.id;
  //   const reasonParts = state.text.split(searchTerm);
  //   const reasonPart1 = reasonParts[0];
  //   const reasonPart2 = searchTerm;
  //   const reasonPart3 = state.text.slice(reasonParts[0].length + searchTerm.length);

  //   //match synonyms
  //   if (index < 0) {
  //     return jQuery('<span><strong class="text-gold">' + code + '</strong> ' +
  //       state.text + '</span>');
  //   }
  //   return jQuery('<span><strong class="text-gold">' + code + '</strong> ' + reasonPart1 +
  //     '<span class="search-bold">' + reasonPart2 + '</span>' + reasonPart3 + '</span>');
  // };

  // templateSelectionCase = (state): JQuery | string => {
  //   return jQuery('<span>' + state.id + '</span>');
  // }

  // onSelectCases(event) {

  // }

  // reasons autocomplete settings
  // setSelect2OptionsReason(): void {

  //   this.select2OptionsReason = {
  //     multiple: true,
  //     placeholder: 'Search for reasons...',
  //     width: '100%',
  //     templateResult: this.templateResultReason,
  //     templateSelection: this.templateSelectionReason,
  //     matcher: this.reasonService.select2Match
  //   };

  // }

  // templateResultReason(state): JQuery | string {

  //   const searchTerm = $('.app-select2.select2-reason input.select2-search__field').val();
  //   const index = state.text.indexOf(searchTerm);
  //   const category = state.additional;
  //   const reasonParts = state.text.split(searchTerm);
  //   const reasonPart1 = reasonParts[0];
  //   const reasonPart2 = searchTerm;
  //   const reasonPart3 = state.text.slice(reasonParts[0].length + searchTerm.length);

  //   //match synonyms
  //   if (index < 0) {
  //     return jQuery('<span>' + state.text +
  //       '<span class="text-gold"> in <strong>' + category + '</strong></span></span>');
  //   }
  //   return jQuery('<span>' + reasonPart1 + '<span class="search-bold">' + reasonPart2 + '</span>' + reasonPart3 +
  //     '<span class="text-gold"> in <strong>' + category + '</strong></span></span>');
  // };

  // templateSelectionReason = (state): JQuery | string => {
  //   return jQuery('<span>' + state.text + '</span>');
  // }

  // onSelectReasons(event) {

  // }

  // documents autocomplete settings
  // setSelect2OptionsDocument(): void {

  //   this.select2OptionsDocument = {
  //     multiple: true,
  //     placeholder: 'Search for documents...',
  //     width: '100%',
  //     templateResult: this.templateResultDocument,
  //     templateSelection: this.templateSelectionDocument,
  //     matcher: this.reasonService.select2Match
  //   };

  // }

  // templateResultDocument(state): JQuery | string {

  //   const searchTerm = $('.app-select2.select2-document input.select2-search__field').val();
  //   const index = state.text.indexOf(searchTerm);
  //   const category = state.additional;
  //   const reasonParts = state.text.split(searchTerm);
  //   const reasonPart1 = reasonParts[0];
  //   const reasonPart2 = searchTerm;
  //   const reasonPart3 = state.text.slice(reasonParts[0].length + searchTerm.length);

  //   //match synonyms
  //   if (index < 0) {
  //     return jQuery('<span>' + state.text +
  //       '<span class="text-gold"> in <strong>' + category + '</strong></span></span>');
  //   }
  //   return jQuery('<span>' + reasonPart1 + '<span class="search-bold">' + reasonPart2 + '</span>' + reasonPart3 +
  //     '<span class="text-gold"> in <strong>' + category + '</strong></span></span>');
  // };

  // templateSelectionDocument = (state): JQuery | string => {
  //   return jQuery('<span>' + state.text + '</span>');
  // }

  // onSelectDocuments(event) {

  // }

  isStageCheckboxEnable(stageValue) {
    return (
      this.alert.action.toString() === '1' && this.disabledStagesForLetter.indexOf(stageValue) > -1
    );
  }

  onSubmitAlertForm() {
    this.formErrorField = '';
    this.generatePcnStagesList();
    this.generatePcnTypeList();
    this.generateAllDates();
    this.configureReasonsDocPoliciesSelected();
    this.alert.policies = this.selectedPolicies;
    console.log(this.alert);

    if (!this.isValidForm()) {
      return;
    }

    if (this.isEditPage) {
      this.adminService.updateAlert(this.alert).subscribe(
        (result) => {
          if (result) {
            this.router.navigate(['/admin/alerts']);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      this.adminService.createAlert(this.alert).subscribe(
        (result) => {
          if (result) {
            this.router.navigate(['/admin/alerts/edit/' + result]);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  isValidForm() {
    if (this.alert.name === null || this.alert.name === '') {
      this.formErrorField = 'name';
      return false;
    } else if (this.alert.startDate === null || this.alert.startDate === undefined) {
      this.formErrorField = 'start-date';
      return false;
    }
    return true;
  }

  isPolicySelected(id) {
    return this.selectedPolicies.indexOf(id) > -1;
  }

  selectPolicyCategory(section) {
    this.selectedPolicyCat = section.categoryId;
    this.visiblePolicieSection = section;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  selectPolicy(id) {
    const policyIndex = this.selectedPolicies.indexOf(id);
    if (policyIndex > -1) {
      this.selectedPolicies.splice(policyIndex, 1);
    } else {
      this.selectedPolicies.push(id);
    }
    this.bounceAlertsBubbleState = Math.random();
  }

  numOfSelectedPolicies(catSection) {
    const sectionPoliciesIds = [];
    catSection.policies.forEach((policy) => {
      sectionPoliciesIds.push(policy.id);
    });

    let numOfPoliciesSelected = 0;
    sectionPoliciesIds.forEach((policyId) => {
      if (this.selectedPolicies.indexOf(policyId) > -1) {
        numOfPoliciesSelected += 1;
      }
    });
    return numOfPoliciesSelected;
  }

  configureReasonsDocPoliciesSelected() {
    this.alert.reasons = this.selectedReasons === null ? [] : this.selectedReasons;
    this.alert.documents = this.selectedDocuments === null ? [] : this.selectedDocuments;
    this.alert.policies = this.selectedPolicies === null ? [] : this.selectedPolicies;
    this.alert.eventCode = this.selectedCases.toString();
  }

  generateAllDates() {
    this.alert.createdOn = this.createdOn;
    this.alert.endDate = this.endDate;
    this.alert.issuedStartDate = this.issuedStartDate;
    this.alert.issuedEndDate = this.issuedEndDate;
    this.alert.modifiedOn = new Date();
    this.alert.startDate = this.startDate;
    this.alert.whenOrdered = this.whenOrdered || new Date();
  }

  generatePcnStagesList() {
    this.alert.stages = [];
    this.pcnStages.forEach((stage) => {
      if (stage.checked) {
        this.alert.stages.push(stage.value);
      }
    });
  }

  generatePcnTypeList() {
    this.alert.pcnTypes = [];
    this.pcnTypes.forEach((type) => {
      if (type.checked) {
        this.alert.pcnTypes.push(type.value);
      }
    });
  }

  onActionChange(value) {
    if (value === '1') {
      this.disableStagesForLetter();
      this.setSelectedPcnStages();
    }
  }

  disableStagesForLetter() {
    this.disabledStagesForLetter.forEach((stage) => {
      const index = this.alert.stages.indexOf(stage);
      if (index > -1) {
        this.alert.stages.splice(index, 1);
      }
    });
  }

  openPoliciesPanel(modal) {
    this.modalService.open(modal, { centered: true });
  }

  // testMe(value) {
  //   console.log(value);
  // }
}
